export default [
  { name: 'Home Address', value: 'Home' },
  { name: 'Main Office Address', value: 'Main Office' },
  { name: 'Branch Office', value: 'Branch Office' },
  { name: 'Second Home', value: 'Second Home' },
  { name: 'Investment', value: 'Investment' },
  { name: 'Mailing', value: 'Mailing' },
];
